import { Controller } from '@hotwired/stimulus';
import Vue from 'vue';

export default class extends Controller {
  static targets = ['template'];
  static values = { staff: Object };

  connect() {
    const el = this.templateTarget;
    const staff = this.staffValue;

    new Vue({
      el,
      data: {
        staff,
      },
      computed: {
        is_master: {
          get: function () {
            return this.staff.is_master ? '1' : '0';
          },
          set: function (value) {
            this.staff.is_master = value === '1';
          },
        },
      },
      methods: {
        has_master_role: function () {
          return (
            this.staff.is_primary === true ||
            this.staff.is_master === true ||
            this.staff.is_admin_login_staff === true ||
            this.staff.is_primary === '1' ||
            this.staff.is_master === '1' ||
            this.staff.is_admin_login_staff === '1'
          );
        },
      },
    });
  }
}
